import moment from "moment";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import CubicCapacityIconSVG from "../../assets/icons/svg/CubicCapacityIconSVG";
import FuelTypeIconSVG from "../../assets/icons/svg/FuelTypeIconSVG";
import HorsePowerIconSVG from "../../assets/icons/svg/HorsePowerIconSVG";
import { getFormatedCarName } from "../../utils/helpers/userCarHelpers/getFormatedCarName";

const UserCarDescriptionCard = ({
    userCar
}) => {
    const formatedMakeName = getFormatedCarName(userCar.Make.name);
    const formetedModelName = getFormatedCarName(userCar.Model.name);

    const cubicData = `${userCar.Motor.cc} cm3`;
    const kwHpData = `${userCar.Motor.kw}/${userCar.Motor.hp} (KW/KS)`;

    const vinData = `Broj šasije (VIN) ${userCar.vin}`;


    const GetLastRegistrationStack = (lastRegistrationDate) => {
        //This should be on the backend, but i get error when i try to modify the response
        //talk about this
        const getRegistrationExpireDateData = () => {
            const today = moment();
            const registrationExpireDate = moment(lastRegistrationDate).add(1, 'year');

            const diffInMonthsBetweenTodayAndRegExpiryDate = registrationExpireDate.diff(today, 'month');

            let isExpiringSoon = false;

            if (diffInMonthsBetweenTodayAndRegExpiryDate === 0) {
                isExpiringSoon = true;
            };

            const registrationExpireDateFormated = registrationExpireDate.format('DD.MM.YYYY.');

            return {
                dateString: `Registrovan do ${registrationExpireDateFormated}`,
                isExpiringSoon: isExpiringSoon
            };
        };


        const { dateString, isExpiringSoon } = getRegistrationExpireDateData();

        return (
            <div style={styles.registrationDiv}>
                <p style={styles.vinText}>
                    {dateString}
                </p>

                {isExpiringSoon && (
                    <div style={styles.expireSoonDiv}>
                        <p style={styles.expireSoonText}>
                            Uskoro istice
                        </p>
                    </div>
                )}

            </div>
        );
    };


    return (
        <div style={styles.mainContainer}>

            <div style={styles.makeAndModelContainer}>
                <p style={styles.makeText}>
                    {formatedMakeName}
                </p>
                <p style={styles.modelText}>
                    {formetedModelName}
                </p>
            </div>

            <div style={styles.engineDataRow}>

                <div style={styles.singleEngineDataRow}>
                    <CubicCapacityIconSVG />
                    <p style={styles.singleEngineDataText}>
                        {cubicData}
                    </p>
                </div>

                <div style={styles.singleEngineDataRow}>
                    <HorsePowerIconSVG />
                    <p style={styles.singleEngineDataText}>
                        {kwHpData}
                    </p>
                </div>

                <div style={styles.singleEngineDataRow}>
                    <FuelTypeIconSVG />
                    {/*MISSING DATA ON THE BACKEND */}
                    <p style={styles.singleEngineDataText}>
                        {"Dizel"}
                    </p>
                </div>

            </div>

            <div style={styles.vinComponent}>
                <p style={styles.vinText}>
                    {vinData}
                </p>
            </div>


            {userCar.last_registration_date && (
                GetLastRegistrationStack(userCar.last_registration_date)
            )}
        </div>
    );
};

export default UserCarDescriptionCard;

const styles = {
    mainContainer: {
        padding: 20,
        backgroundColor: "#F3F4F6",
        border: "1px solid #CBD5E1",
        borderRadius: 8,
        height: "max-content"
    },
    makeAndModelContainer: {
        display: "flex",
        alignItems: "center",
        gap: 10
    },
    makeText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "34px",
    },
    modelText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "34px",
        fontWeight: 600
    },
    engineDataRow: {
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        gap: 30,
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    singleEngineDataRow: {
        display: 'flex',
        alignItems: 'center',
    },
    singleEngineDataText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 600
    },
    vinText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px"
    },
    vinComponent: {
        marginBottom: 10
    },
    registrationDiv: {
        display: 'flex',
        gap: 10
    },
    expireSoonDiv: {
        paddingInline: 8,
        backgroundColor: '#D32F2F',
        borderRadius: 10
    },
    expireSoonText: {
        color: "#FFFFFF"
    }

};